'use strict';

/**
 * Validate form for password update on customer profile page
 */
function validateForm() {
    const $currentPassword = $('#currentPassword');
    const $newPassword = $('#newPassword');
    const $submitUpdatedPasswordBtn = $('.submit-new-password');

    const isCurrentPasswordProvided = ($currentPassword.val().length > 0);
    const isvalidPassword = $newPassword.closest('.input-group').hasClass('valid');
    const isPasswordConfirmed = isNewPasswordConfirmed();

    if (isCurrentPasswordProvided && isvalidPassword && isPasswordConfirmed) {
        $submitUpdatedPasswordBtn.removeAttr('disabled');
    } else {
        $submitUpdatedPasswordBtn.attr('disabled', 'disabled');
    }
}

/**
 * Toggle invalid class for password update input forms
 * @param {jQuery} $input password input
 * @param {boolean} inputCondition toggle condition
 * @param {string} message validation message
 */
function toggleInvalidFor($input, inputCondition, message) {
    const $invalidFeedback = $input.closest('.form-group').find('.invalid-feedback');
    const validationMessage = message || $input.data('unmatched') || '';
    if (!inputCondition) {
        $input.addClass('is-invalid');
        $invalidFeedback.show().text(validationMessage);
    } else {
        $input.removeClass('is-invalid');
        $invalidFeedback.empty().hide();
    }
}

/**
 *
 * @returns {boolean} the new password is confirmed
 */
function isNewPasswordConfirmed() {
    const $newConfirmedPassword = $('#newPasswordConfirm');
    const $newPassword = $('#newPassword');

    return ($newPassword.val() === $newConfirmedPassword.val());
}

/**
* Adds the 'is-invalid' class to the children's day, month and year form fields and displays the validation message
* @param {number} index - the index of the child
*/
function invalidateChildrenForm(index) {
    $('#dwfrm_profile_children_child' + index + '_day').addClass('is-invalid');
    $('#dwfrm_profile_children_child' + index + '_month').addClass('is-invalid');
    $('#dwfrm_profile_children_child' + index + '_year').addClass('is-invalid');
    $('#validateBirthdate' + index).css('display', 'block');
}

/**
* Validates the form for the children in the profile page
* @returns {boolean} - true if the form is valid, false otherwise
*/
function validateChildrenForm() {
    // Reset all validators
    $('.invalid-feedback').each(function (i) {
        var el = $($('.invalid-feedback')[i]);
        el.removeClass('d-block');
    });

    var childrenNumber = $('.number-of-children').attr('data-children-count');
    var isValid = true;

    for (var i = 1; i <= childrenNumber; i++) {
        var childForm = {
            isNotBorn: $('#isnotborn-' + i)[0].checked,
            firstName: $('#dwfrm_profile_children_child' + i + '_childfirstname')[0].value,
            dayBirth: $('#dwfrm_profile_children_child' + i + '_day')[0].value,
            monthBirth: $('#dwfrm_profile_children_child' + i + '_month')[0].value,
            yearBirth: $('#dwfrm_profile_children_child' + i + '_year')[0].value
        };

        childForm.birthdate = new Date(childForm.yearBirth, Number(childForm.monthBirth) - 1, childForm.dayBirth);

        var genders = $('input[name=dwfrm_profile_children_child' + i + '_childgender]');
        // eslint-disable-next-line no-loop-func
        var checkedGender = genders.filter(gender => genders[gender].checked);
        childForm.gender = checkedGender;

        isValid = handleChildForm(childForm, i);
        if (!isValid) break;
    }
    return isValid;
}

/**
* Validates the form of a child
* @param {Object} child - the child object
* @param {number} index - the index of the child in the form
* @returns {boolean} - true if the form is valid, false otherwise
*/
function handleChildForm(child, index) {
    var isValid = true;
    // if isNotBorn
    if (child.isNotBorn) {
        // no birthDate before today
        if (child.dayBirth == 0
        || child.monthBirth == 0
        || child.yearBirth == 0
        || child.birthdate < new Date()) {
            isValid = false;
            invalidateChildrenForm(index);
        }
    } else {
        // must have a name
        if (!child.firstName || child.firstName === '') {
            isValid = false;
            $('#dwfrm_profile_children_child' + index + '_childfirstname').addClass('is-invalid');
            $('#validateFirstname' + index).css('display', 'block');
        }

        // no birthDate after today
        if (child.dayBirth == 0
            || child.monthBirth == 0
            || child.yearBirth == 0
            || child.birthdate > new Date()) {
            isValid = false;
            invalidateChildrenForm(index);
        }

        // gender can not be surprise
        if (child.gender[0].value == 2) {
            isValid = false;
            $('#validateGender' + index).addClass('d-block');
        }
    }

    return isValid;
}

module.exports = {
    validateForm: validateForm,
    toggleInvalidFor: toggleInvalidFor,
    isNewPasswordConfirmed: isNewPasswordConfirmed,
    validateChildrenForm: validateChildrenForm
};
